module.exports = __webpack_public_path__ + "img/carRegister.db37aadd.png";